import { useRoute, Link } from "wouter";
import { useAuth } from "../lib/auth";
import { usePostFlowState } from "./post-flow/usePostFlowState";
import { usePostFlowDraft } from "./post-flow/usePostFlowDraft";
import { usePostFlowPreview } from "./post-flow/usePostFlowPreview";
import { createPostFlowPublication } from "./post-flow/createPostFlowPublication";
import { createItemPostingFields } from "./post-flow/createItemPostingFields";
import { createProjectRfqPostingFields } from "./post-flow/createProjectRfqPostingFields";
import { createPostFlowReview } from "./post-flow/createPostFlowReview";
import { PostFlowView } from "./post-flow/PostFlowView";
import { useListingPurchaseOffer } from "./post-flow/useListingPurchaseOffer";

export default function PostFlow() {
  const [, params] = useRoute("/post/:type");
  const { user, loading, companyMarketplaceAccess, canStartMarketplaceActivity } = useAuth();
  if (loading) return <div className="container-x py-10 text-mut">Loading posting form…</div>;
  // [business.history-continuation](../../../docs/product/businesses.md#business-history-continuation): former membership/retired scopes continue existing dealings only.
  if (companyMarketplaceAccess === "history") return <div className="container-x py-10 max-w-2xl"><div className="card p-6 space-y-3"><h1 className="text-xl font-bold text-navy">Business history</h1><p className="text-sm text-mut">Use this profile to finish existing dealings. Select Personal or a business you own for new postings. Your saved drafts are retained.</p><Link href={`/company/${user?.activeContext?.slice(8)}/dashboard`} className="btn-outline">View Business history</Link></div></div>;
  // [business.marketplace-eligibility](../../../docs/product/businesses.md#business-marketplace-eligibility): keep private draft recovery intact without opening a company
  // publication form before current verification is known and approved.
  if (!canStartMarketplaceActivity) return (
    <div className="container-x py-10 max-w-2xl"><div className="card p-6 space-y-3">
      <h1 className="text-xl font-bold text-navy">Business verification required</h1>
      <p className="text-sm text-mut">{companyMarketplaceAccess === "checking" ? "Checking your business verification…" : "Complete business verification before creating a posting. Your saved drafts are retained."}</p>
      <Link href={`/company/${user?.activeContext?.slice(8)}/edit`} className="btn-red">Go to business verification</Link>
    </div></div>
  );
  if (params?.type === "resume") return (
    <div className="container-x py-10 max-w-2xl"><div className="card p-6 space-y-4">
      <h1 className="text-xl font-bold text-navy">Your résumé belongs to your profile</h1>
      <p className="text-sm text-mut">Update your shared profile and manage your résumé files from your dashboard. When you are ready, turn on Show me in Jobseekers in profile settings.</p>
      <div className="flex flex-wrap gap-3">
        <Link href="/worker-profile" className="btn-outline">Edit profile</Link>
        <Link href="/dashboard" className="btn-red">Manage résumé files</Link>
        <Link href="/settings/profile-privacy" className="btn-outline">Jobseeker discovery settings</Link>
      </div>
    </div></div>
  );
  return <ListingPostFlow key={`${user?.id ?? "guest"}:${user?.activeContext || "personal"}:${params?.type || "job"}`} />;
}

function ListingPostFlow() {
  const state = usePostFlowState();
  const draftModel = usePostFlowDraft(state);
  const preview = usePostFlowPreview(draftModel);
  const purchase = useListingPurchaseOffer(preview);
  const publication = createPostFlowPublication(purchase);
  const fields = { ...publication, ...createItemPostingFields(publication), ...createProjectRfqPostingFields(publication) };
  const model = createPostFlowReview(fields);
  if (!model.draft.ready) return <div className="container-x py-10 text-mut">Restoring posting draft…</div>;
  return <PostFlowView model={model} />;
}
